module.exports = __webpack_public_path__ + "img/medicine_tag.8cc6e171.png";